import { callApi } from '@/api/apibase'

export const createPrivateCustomer = function (verificationCode, name, email, phoneNumber, address, zipCode, city) {
  const requestData = {
    VerificationCode: verificationCode,
    Name: name,
    PrimaryEmail: email,
    PrimaryPhoneNumber: phoneNumber,
    Address: address,
    ZipCode: zipCode,
    City: city
  }
  return callApi('POST', '/api/external/greencourse/ValidateAndCreateOrUpdateCustomer', requestData)
}
